<section class="lump-sum-details-card">
  <div class="d-flex align-items-center justify-content-between">
    <div class="responsive-card-title" i18n>Lump Sum Payment Details</div>
    <app-tertiary-button
      *ngIf="hasHistory$ | async"
      i18n
      [size]="BaseButtonSizeEnum.xs"
      (buttonClicked)="viewPastLumpSumPayments.emit()">
      View Past Lump Sum Payments
    </app-tertiary-button>
  </div>

  <ng-container *ngIf="scheduledPayment$ | async as scheduled; else noUpcoming">
    <div class="d-flex flex-column gap-1 mt-4">
      <div class="section-label" i18n>Upcoming</div>
      <div class="upcoming-payment-card">
        <div class="payment-date flex-grow-1">{{ scheduled.formattedDesiredPaymentDate | date : 'MMMM yyyy' }}</div>
        <div class="payment-amount">{{ scheduled.paymentAmount | currency }}</div>
      </div>
    </div>
  </ng-container>

  <ng-template #noUpcoming>
    <ng-container *ngIf="hasHistory$ | async; else noHistory">
      <div class="empty-message mt-4" i18n>There are no upcoming lump sum payments</div>
    </ng-container>
    <ng-template #noHistory>
      <div class="empty-message mt-2" i18n>There are no upcoming or past lump sum payments</div>
    </ng-template>
  </ng-template>
</section>
